import { EntityState, PayloadAction } from '@reduxjs/toolkit';

import { PropertyDataState } from '../../types.ts';
import { propertyDataAdapter } from '../propertyDataAdapter.ts';
import { getChangedEntityFromEditableData } from './utils/getChangedEntityFromEditableData.ts';

export const setSiteValueCommentaryReducer = (
  state: EntityState<PropertyDataState, string>,
  action: PayloadAction<string>,
) => {
  const { subject } = state.entities;
  if (!subject) return;

  propertyDataAdapter.updateOne(
    state,
    getChangedEntityFromEditableData(subject, { siteValueCommentary: action.payload }),
  );
};
